import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import DocsLayout from 'components/docs-layout/DocsLayout';
import { mapBusinessDpaToSections } from 'utils/legal/sections';

const BusinessDataProcessingAgreement = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapBusinessDpaToSections(t), [language]);
  const title = t('title', 'businessdpa') || 'Business Data Processing Agreement';
  const lastUpdated = t('lastUpdated', 'businessdpa') || '';

  return <DocsLayout title={title} lastUpdated={lastUpdated} sections={sections} navigationConfig={{}} showBindingNotice={true} />;
};

export default BusinessDataProcessingAgreement;

